import { render } from "./LaRevue.vue?vue&type=template&id=b0f0607c&scoped=true&ts=true"
import script from "./LaRevue.vue?vue&type=script&lang=ts"
export * from "./LaRevue.vue?vue&type=script&lang=ts"

import "./LaRevue.vue?vue&type=style&index=0&id=b0f0607c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f0607c"]])

export default __exports__